<div class="w-100" *ngIf="sectionFeatureType">
  <h2 *ngIf="showTitle" class="text-center fw-bolder mb-2 fs-md-16 px-3 lh-sm">
    {{ sectionFeatureType.title }}
  </h2>
  <div *ngIf="!loading; else loadingSpinner" class="">
    <div *ngIf="registrations && registrations.length > 0; else noListings">

      <!-- OVERFLOW -->
      <div *ngIf="overflow" style="overflow-x: auto"
        class="d-flex align-items-center justify-content-start {{ reversed ? 'flex-row-reverse' : 'flex-row' }} gap-4">
        <ng-container *ngFor="let registration of registrations; let index = index">
          <div class="">
            <pla-plate [plateSize]="plateSize" [plate]="registration" secondaryText="{{ index + 1 | ordinalNumber }}"
              [showIndex]="showIndex" [mobileTiny]="mobileTiny" [showPrice]="showPrice" [showPence]="false"
              [penceLimit]="10000" [priceFontSize]="priceFontSize" [priceClass]="priceClass"
              [customClass]="plateClass"></pla-plate>
          </div>
        </ng-container>
      </div>

      <!-- FLEX -->
      <div *ngIf="!overflow && flex" class="featured-container" [style.gap]="showPrice ? '15px' : '30px'">
        <ng-container *ngFor="let registration of registrations; let index = index">
          <div class="featured-item">
            <pla-plate [plateSize]="plateSize" [plate]="registration" secondaryText="{{ index + 1 | ordinalNumber }}"
              [showIndex]="showIndex" [mobileTiny]="mobileTiny" [showPrice]="showPrice" [showPence]="false"
              [penceLimit]="10000" [priceFontSize]="priceFontSize" [priceClass]="priceClass"
              [customClass]="plateClass"></pla-plate>
          </div>
        </ng-container>
      </div>

      <!-- BS COLUMN -->
      <ng-container *ngIf="!overflow && !flex">
        <div class="container-fluid">
          <div class="row">
            <ng-container *ngFor="let __ of ['','','','']; let _index = index">
              <div class="d-none d-xl-block col-xl-1"></div>
              <ng-container
                *ngFor="let registration of registrations | slice:(_index * 5):((_index + 1) * 5); let index = index">
                <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2"
                  [ngClass]="{ 'py-2': showPrice, 'py-1': !showPrice }">
                  <pla-plate [plateSize]="plateSize" [plate]="registration"
                    secondaryText="{{ index + 1 | ordinalNumber }}" [showIndex]="showIndex" [mobileTiny]="mobileTiny"
                    [showPrice]="showPrice" [showPence]="false" [penceLimit]="10000" [priceFontSize]="priceFontSize"
                    [priceClass]="priceClass" [customClass]="plateClass"></pla-plate>
                </div>
              </ng-container>
              <div class="d-none d-xl-block col-xl-1"></div>
            </ng-container>
          </div>
        </div>
      </ng-container>

    </div>
    <ng-template #noListings>
      <div *ngIf="showIfEmpty" class="featured-container">
        <p style="text-align: center; width: 100%; margin: 20px auto">
          No featured registrations at this time.
        </p>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #loadingSpinner>
  <div class="full spinner-loader">
    <div class="py-3">
      <mat-progress-spinner class="spinner cyan" mode="indeterminate" [color]="'#327b8d'"
        [diameter]="60"></mat-progress-spinner>
    </div>
    <span>Loading Featured Plates...</span>
  </div>
</ng-template>